import { render, staticRenderFns } from "./Traceability.vue?vue&type=template&id=1af2dbde&scoped=true&"
import script from "./Traceability.vue?vue&type=script&lang=js&"
export * from "./Traceability.vue?vue&type=script&lang=js&"
import style0 from "./Traceability.vue?vue&type=style&index=0&id=1af2dbde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af2dbde",
  null
  
)

export default component.exports